var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('coach-availability-calendar',{attrs:{"coach":_vm.coach}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }